export default "/images/framework/ChangeAvatarCht.37fa5163.svg?37fa5163";